// @flow
import { createSelector } from "reselect";
import _ from "lodash";
import { getTeamsById } from "../league";
import {TDraftTeamsById} from "../../types";

export const getUsersFromTeamsById = createSelector(
	getTeamsById,
	(teams_by_id: TDraftTeamsById) => _.keyBy(teams_by_id, "user_id")
);